import React from 'react';

const ErrorTablePopup = ({ errorList, toggleErrorPopup }) => {
  const renderErrors = () => {
    return Object.keys(errorList).map(id => {
      var data = errorList[id];
      return (
        <div className="table_row border_t_1 border_color_1" key={id}>
          <div className="tabcel align_middle pad10">{data.start}</div>
          <div className="tabcel align_middle pad10">{data.end}</div>
          <div className="tabcel align_middle pad10">{data.status}</div>
          <div className="tabcel align_middle pad10">{data.type}</div>
          <div className="tabcel align_middle pad10">{data.message}</div>
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <div className="modal_overlay transbg1">&nbsp;</div>
      <div className="pop_colum">
        <div className="pop_inner">
          <div className="apndwrap wdhpx900 shwd2 bg1 pad30 round5 ovr zIndex999">
            <div className="popup_scroll">
              <div
                className="close_popup facnt full-round bgcolr6"
                onClick={() => toggleErrorPopup(false, [])}
              >
                {' '}
                <i className="fa fa-times txtcolr1"></i>
              </div>
              <div className="wrapper">
                <div className="scrolly_auto">
                  <div className="table_col table_fixed">
                    <div className="table_row bg2_8">
                      <div className="tabcel align_middle pad10 tu bld wdhpx100">Start Date</div>
                      <div className="tabcel align_middle pad10 tu bld wdhpx100">End Date</div>
                      <div className="tabcel align_middle pad10 tu bld wdhpx100">Status</div>
                      <div className="tabcel align_middle pad10 tu bld wdhpx100">Update Type</div>
                      <div className="tabcel align_middle pad10 tu bld wdhpx100">Message</div>
                    </div>
                    {renderErrors()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ErrorTablePopup;
